module.exports = __webpack_public_path__ + "static/media/intro-tab-camera.21d0e382.png";